function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".fill-color{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;}"));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "settings");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Tools_1",
  "data-name": "Tools 1"
}, /*#__PURE__*/React.createElement("path", {
  className: "fill-color",
  d: "M12.5,16A1.5,1.5,0,0,0,11,14.5a1.55,1.55,0,0,0-.43.07l-.72-.72a1.21,1.21,0,0,1,0-1.71l2.29-2.29a1.21,1.21,0,0,1,1.71,0l.72.72a1.55,1.55,0,0,0-.07.43A1.5,1.5,0,0,0,16,12.5a1.55,1.55,0,0,0,.43-.07l6.36,6.36a2.41,2.41,0,0,1,0,3.41h0l-.59.59a2.41,2.41,0,0,1-3.41,0h0l-6.36-6.36A1.55,1.55,0,0,0,12.5,16Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "fill-color",
  d: "M10.25,11.75,4,5.5H3.08A1,1,0,0,1,2.21,5L.5,2,2,.5,5,2.21a1,1,0,0,1,.5.87V4l6.25,6.25"
}), /*#__PURE__*/React.createElement("path", {
  className: "fill-color",
  d: "M14.87,12l.11-.11a4.85,4.85,0,0,1,3.5-1.35h0a5,5,0,0,0,5-5,5,5,0,0,0-.61-2.34L21.46,5.32A1.55,1.55,0,0,1,20.17,6h-.25a2.85,2.85,0,0,1-2.64-1.79,1.54,1.54,0,0,1,.11-1.37L18.78.54H18.5a5,5,0,0,0-5,5h0A5.17,5.17,0,0,1,12,9.2l-.64.64"
}), /*#__PURE__*/React.createElement("path", {
  className: "fill-color",
  d: "M9.84,11.34,1.09,20.1a2,2,0,0,0,0,2.83L1.2,23A2.09,2.09,0,0,0,4,22.8l8-8"
}));

var SvgControl = function SvgControl(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgControl, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/control.c6fe4b41.svg";
export { ForwardRef as ReactComponent };